<template>
  <div class="pi">
    <a-descriptions title="个人信息" layout="vertical" :bordered="true">
      <a-descriptions-item label="昵称"  span="3">
        {{ netuser.name }}
      </a-descriptions-item>
      <!-- <a-descriptions-item label="手机号码">
        {{ netuser.iphone | isNUll }}
      </a-descriptions-item>
      <a-descriptions-item label="邮箱">
        {{ netuser.mailbox | isNUll }}
      </a-descriptions-item> -->
      <a-descriptions-item label="简介" span="3">
        {{ netuser.introduce | isNUll }}
      </a-descriptions-item>
      <a-descriptions-item label="地区" span="1">
        {{ netuser.province | isNUll }}- {{ netuser.city | isNUll }}-
        {{ netuser.area | isNUll }}
      </a-descriptions-item>
      <a-descriptions-item label="详细地址" span="2">
        {{ netuser.address | isNUll }}
      </a-descriptions-item>
      <a-descriptions-item label="创建时间">
        {{ netuser.userMake | isNUll }}
      </a-descriptions-item>
    </a-descriptions>
    <div class="upstyle">
      <a-button type="primary"><router-link to="/User/uppi"> 去修改 </router-link></a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "pi",
  data() {
    return {
      pi: "嗨",
      netuser: this.$store.state.netuser,
    };
  },
};
</script>

<style lang="less" scoped>
.pi {
  padding: 10px;
  width: 100%;
  background-color: rgb(255, 255, 255);
  .upstyle{
    text-align: center;
    margin-top: 10px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/pi/pi.vue